import { jsx } from "react/jsx-runtime";
import { SearchBox, Input, Combobox } from "@zillow/constellation";
import { useCallback } from "react";
import { installations } from "./installations.json.esm.js";
const OPTIONS = installations;
const MilitaryInstallationSelector = ({
  onChange
}) => {
  const handleChange = (value, meta) => {
    typeof onChange === "function" && onChange(value, meta);
  };
  const renderInput = useCallback(({
    onClear: _onClear,
    onTagClose: _onTagClose,
    ...rest
  }) => /* @__PURE__ */ jsx(SearchBox, { input: /* @__PURE__ */ jsx(Input, { placeholder: "Start typing installation name", ...rest }) }), []);
  return /* @__PURE__ */ jsx(Combobox, { onChange: handleChange, options: OPTIONS, renderInput, showLabelForValue: true });
};
export {
  MilitaryInstallationSelector as default
};
